import { z } from 'zod'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { OrderStatusSchema, OrdersStatusPatchRequestSchema } from '~/services/api/generated'
import { fieldNormalizer } from '~/services/api/contracts/fieldNormalizer'

const normalize = fieldNormalizer({
  enums: [{ field: 'status', options: OrderStatusSchema.options }]
})

const schema = OrdersStatusPatchRequestSchema.strict()

export const OrdersStatusPatch = (_context: NoContext): z.ZodType<z.output<typeof schema>> =>
  z.preprocess(normalize, schema)
